import { OrganizationService, UserService } from '@acme/api/admin';
import { OpenAPI } from '@acme/api/shared';
import type { OrganizationResponse } from '@acme/domains';
import { UserStore } from '@acme/domains';
import {
  ApiErrorHandlerProvider,
  AuthProvider,
  ErrorProvider,
  MessageHubProvider,
} from '@acme/features';
import { ModalProvider, adminTheme } from '@acme/foundation';
import { AdminRoutesComponent } from '@app/router/routes';
import { NavigationProvider } from '@shared/navigation';
import { ThemeProvider } from 'flowbite-react';
import { BrowserRouter } from 'react-router-dom';

const userStore = new UserStore({
  getUser: async () => {
    const data = await UserService.getApiAdminV1User();
    return { data: data.data ?? null };
  },
  getOrganization: async () => {
    const res = await OrganizationService.getApiAdminV1Organization();
    const api = res.data ?? null;
    const data: OrganizationResponse | null = api
      ? {
          ...api,
          role:
            api.role?.id != null
              ? { id: api.role.id, name: api.role.name ?? '' }
              : undefined,
        }
      : null;
    return { data };
  },
  setToken: (token: string) => {
    OpenAPI.TOKEN = async () => {
      const tokenString = localStorage.getItem('token');
      if (tokenString) {
        const tokenResponse = JSON.parse(tokenString);
        return tokenResponse?.accessToken || '';
      }
      return '';
    };
  },
  clearToken: () => {
    OpenAPI.TOKEN = undefined;
  },
});

export function AdminPage() {
  return (
    <BrowserRouter>
      <ThemeProvider theme={adminTheme}>
        <ModalProvider>
          <ErrorProvider>
            <AuthProvider store={userStore}>
              <MessageHubProvider>
                <NavigationProvider>
                  <ApiErrorHandlerProvider>
                    <AdminRoutesComponent />
                  </ApiErrorHandlerProvider>
                </NavigationProvider>
              </MessageHubProvider>
            </AuthProvider>
          </ErrorProvider>
        </ModalProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}
